const inStockRouter = [
    {
        path:'itemImport',
        name: 'inStock-itemImport',
        component:() => import(/* webpackChunkName: "about" */ '../views/inStock/itemImport.vue'),
    },
    {
        path:'list',
        name:'inStock-list',
        component: () => import(/* webpackChunkName: "about" */ '../views/inStock/lists/list.vue'),
        redirect: { name: 'inStock-consumables' },
        children:[
            {
                path:'consumables',
                name:'inStock-consumables',
                component: () => import(/* webpackChunkName: "about" */ '../views/inStock/lists/consumables.vue')
            },
            {
                path:'appliance',
                name:'inStock-appliance',
                component: () => import(/* webpackChunkName: "about" */ '../views/inStock/lists/appliance.vue')
            },
            {
                path:'medication',
                name:'inStock-medication',
                component: () => import(/* webpackChunkName: "about" */ '../views/inStock/lists/medication.vue')
            },
            {
                path:'food',
                name:'inStock-food',
                component: () => import(/* webpackChunkName: "about" */ '../views/inStock/lists/food.vue')
            },
            {
                path:'daily',
                name:'inStock-daily',
                component: () => import(/* webpackChunkName: "about" */ '../views/inStock/lists/daily.vue')
            },
            
        ],
    },{
        path:'item',
        name:'inStock-item',
        redirect: { name: 'inStock-item-list' },
        children:[
            {
                path:'list',
                name:'inStock-item-list',
                component: () => import(/* webpackChunkName: "about" */ '../views/inStock/item/list/list.vue'),
                // redirect: { name: 'inStock-item-list-consumables' },
                // children:[
                //     {
                //         path:'consumables',
                //         name:'inStock-item-list-consumables',
                //         component: () => import(/* webpackChunkName: "about" */ '../views/inStock/item/list/consumables.vue')
                //     },
                //     {
                //         path:'appliance',
                //         name:'inStock-item-list-appliance',
                //         component: () => import(/* webpackChunkName: "about" */ '../views/inStock/item/list/appliance.vue')
                //     },
                //     {
                //         path:'medication',
                //         name:'inStock-item-list-medication',
                //         component: () => import(/* webpackChunkName: "about" */ '../views/inStock/item/list/medication.vue')
                //     },
                //     {
                //         path:'food',
                //         name:'inStock-item-list-food',
                //         component: () => import(/* webpackChunkName: "about" */ '../views/inStock/item/list/food.vue')
                //     },
                //     {
                //         path:'daily',
                //         name:'inStock-item-list-daily',
                //         component: () => import(/* webpackChunkName: "about" */ '../views/inStock/item/list/daily.vue')
                //     },
                    
                // ],
            },
            {
                path:'create',
                name:'inStock-item-create',
                component: () => import(/* webpackChunkName: "about" */ '../views/inStock/item/create.vue'),
            },{
                path:'detail/:id',
                name:'inStock-item-detail',
                component: () => import(/* webpackChunkName: "about" */ '../views/inStock/item/detail.vue'),
            },{
                path:'edit/:id',
                name:'inStock-item-edit',
                component: () => import(/* webpackChunkName: "about" */ '../views/inStock/item/edit.vue'),
            }
        ],
    },{
        path:'itemType',
        name:'inStock-itemType',
        redirect: { name: 'inStock-itemType-list' },
        children:[
            {
                path:'list',
                name:'inStock-itemType-list',
                component: () => import(/* webpackChunkName: "about" */ '../views/inStock/itemType/list.vue'),
                redirect: { name: 'inStock-itemType-list-consumables' },
                children:[
                    {
                        path:'consumables',
                        name:'inStock-itemType-list-consumables',
                        component: () => import(/* webpackChunkName: "about" */ '../views/inStock/itemType/consumables.vue')
                    },
                    {
                        path:'appliance',
                        name:'inStock-itemType-list-appliance',
                        component: () => import(/* webpackChunkName: "about" */ '../views/inStock/itemType/appliance.vue')
                    },
                    {
                        path:'medication',
                        name:'inStock-itemType-list-medication',
                        component: () => import(/* webpackChunkName: "about" */ '../views/inStock/itemType/medication.vue')
                    },
                    {
                        path:'food',
                        name:'inStock-itemType-list-food',
                        component: () => import(/* webpackChunkName: "about" */ '../views/inStock/itemType/food.vue')
                    },
                    {
                        path:'daily',
                        name:'inStock-itemType-list-daily',
                        component: () => import(/* webpackChunkName: "about" */ '../views/inStock/itemType/daily.vue')
                    },
                    
                ],
            }  
        ],
    },{
        
        path:'purchase',
        name:'inStock-purchase',
        redirect: { name: 'inStock-purchase-list' },
        children:[
            {
                path:'list',
                name:'inStock-purchase-list',
                component: () => import(/* webpackChunkName: "about" */ '../views/inStock/purchase/list.vue'),
                redirect: { name: 'inStock-purchase-list-inPurchase' },
                children:[
                    {
                        path:'inPurchase',
                        name:'inStock-purchase-list-inPurchase',
                        component: () => import(/* webpackChunkName: "about" */ '../views/inStock/purchase/inPurchase.vue')
                    },{
                        path:'inStock',
                        name:'inStock-purchase-list-inStock',
                        component: () => import(/* webpackChunkName: "about" */ '../views/inStock/purchase/inStock.vue')
                    },
                ]
            },{
                path:'create',
                name:'inStock-purchase-create',
                component: () => import(/* webpackChunkName: "about" */ '../views/inStock/purchase/create.vue'),
            },{
                path:'detail/:id',
                name:'inStock-purchase-detail',
                component: () => import(/* webpackChunkName: "about" */ '../views/inStock/purchase/detail.vue'),
            }
        ]

    }
    
  ]
  export default inStockRouter